import { Link } from 'react-router-dom';

function GASidebar() {
  return (
    <div className="projects-sidebar">
      <h1>Gallery</h1>
      <ul>
        <li><Link to="/semi-d">Semi-D</Link></li>
        <li><Link to="/landed">Landed</Link></li>
        <li><Link to="/commercial">Commercial</Link></li>
        <li><Link to="/condominium">Condominium</Link></li>
      </ul>
    </div>
  );
}

export default GASidebar;
